import { render, staticRenderFns } from "./TosfHeiProfile_Dashboard.vue?vue&type=template&id=1621ec33&scoped=true"
import script from "./TosfHeiProfile_Dashboard.vue?vue&type=script&lang=js"
export * from "./TosfHeiProfile_Dashboard.vue?vue&type=script&lang=js"
import style0 from "./TosfHeiProfile_Dashboard.vue?vue&type=style&index=0&id=1621ec33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1621ec33",
  null
  
)

export default component.exports